import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { conditionTargetsSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_stacktrace/qa-operations-core/condition-targets/')({
  validateSearch: zodValidator(conditionTargetsSearchSchema)
});